<script lang="ts">
	//Design system components
	import {
		Label,
		LabelV2,
		type DeviceButtonV2PropsTypes,
		type LabelV2PropsTypes,
	} from '@Shelly/shelly-design-system/index';
	//Components
	import ControlOnOffAddon from 'src/components/Controls/Single/ControlOnOffAddon.svelte';
	import ControlOnOffLEDStrip from 'src/components/Controls/Single/ControlOnOffLEDStrip.svelte';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';
	import { getLedStripComponent } from 'src/helpers/interface_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';

	export let device: Device,
		status: DeviceStatusG2,
		statuses,
		useV2Components = false,
		type = '',
		deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = {};

	export let labelV2Props: Partial<LabelV2PropsTypes> = {};

	$: outputs = statuses.filter((i) => i.peripheralType === 'switch');
	$: mainLabel = statuses.find((i) => i.main);
	$: ledStripComponent = getLedStripComponent(status);
</script>

{#if outputs.length}
	<div class="d-flex gap-s align-items-center">
		{#each outputs as output, _i}
			<ControlOnOffAddon
				{useV2Components}
				{device}
				{status}
				component={output.sensor.component}
				{deviceButtonV2Props}
			/>
		{/each}
	</div>
{:else if ledStripComponent}
	<ControlOnOffLEDStrip
		{useV2Components}
		{device}
		{status}
		component={ledStripComponent}
		{deviceButtonV2Props}
		class="align-self-center"
	/>
{:else if mainLabel}
	{#if useV2Components}
		<LabelV2
			class="align-self-center max-width-full"
			icon={mapIconSolidWeightToLight(mainLabel.icon || 'fas fa-sensor')}
			value={mainLabel.value || ''}
			size={type === 'widget' ? 'xl' : 'l'}
			iconColor={mainLabel.iconColor}
			{...labelV2Props}
		/>
	{:else}
		<Label
			class="align-self-center max-width-full"
			icon={mainLabel.icon || 'fas fa-sensor'}
			value={mainLabel.value || ''}
			size={type === 'widget' ? 'xl' : 'l'}
			iconColor={mainLabel.iconColor}
		/>
	{/if}
{/if}
